(() => {
  if (window.__SQ_FAVORITES_ACTION_CART_FIX__) return;
  window.__SQ_FAVORITES_ACTION_CART_FIX__ = true;

  const ACTION_SELECTOR = [
    '[data-lcs-favorites-add-selected]',
    '[data-lcs-favorites-buy-selected]',
    '[data-lcs-favorite-add]',
    '[data-lcs-favorite-buy]',
    '[data-lcs-expanded-add]',
    '[data-lcs-expanded-buy]',
    '[data-sqyml2-add]',
    '[data-sqyml2-buy]',
    '[data-lcs-recommend-add]',
    '[data-lcs-recommend-buy]'
  ].join(',');

  const BUY_SELECTOR = [
    '[data-lcs-favorites-buy-selected]',
    '[data-lcs-favorite-buy]',
    '[data-lcs-expanded-buy]',
    '[data-sqyml2-buy]',
    '[data-lcs-recommend-buy]'
  ].join(',');

  const EXPANDED_SELECTOR = '[data-lcs-favorite-expanded]';
  const PAGE_SELECTOR = '[data-lcs-favorites-page]';
  const DRAWER_COMPONENT_SELECTOR = 'cart-drawer-component';
  const OPENERS = [
    '[data-lcs-universal-choose]',
    '[data-pick-quick-open]',
    '[data-sq-universal-expanded-open]',
    '[data-lcs-favorite-expand]',
    '[data-sqyml2-expand]',
    '[data-lcs-recommend-expand]',
    '[data-sqfd-open]'
  ].join(',');

  const clean = (value) => String(value ?? '').trim();
  const positiveInteger = (value) => Math.max(1, Math.floor(Number(value) || 1));
  const rootPath = () => String(window.Shopify?.routes?.root || '/').replace(/\/?$/, '/');
  const nextFrame = () => new Promise((resolve) => requestAnimationFrame(resolve));
  const allPages = () => Array.from(document.querySelectorAll(PAGE_SELECTOR));

  const modalForPage = (page) => page?.querySelector(EXPANDED_SELECTOR) || null;
  const activePage = () => allPages().find((page) => modalForPage(page)?.hidden === false)
    || allPages().find((page) => page.__lcsFavoritesPage?.openExpanded)
    || null;
  const pageFor = (node) => node?.closest?.(PAGE_SELECTOR) || activePage();
  const controllerFor = (node) => pageFor(node)?.__lcsFavoritesPage || null;

  const getItemFromFavoriteCard = (button) => {
    const card = button.closest('[data-lcs-favorite-card]');
    const controller = controllerFor(button);
    if (!card || !controller) return null;
    const key = clean(card.dataset.favoriteKey);
    const item = controller.getFavorites?.().find((favorite) => clean(favorite.key) === key);
    if (!item) return null;
    return {
      ...item,
      quantity: positiveInteger(card.querySelector('[data-lcs-favorite-quantity]')?.value || item.quantity)
    };
  };

  const getItemFromRecommendationCard = (button) => {
    const card = button.closest('[data-sqyml2-card],[data-lcs-recommend-card]');
    if (!card) return null;
    const quantity = positiveInteger(card.querySelector('[data-sqyml2-quantity],[data-lcs-recommend-quantity]')?.value || 1);
    return {
      ...(card.__sqUniversalItem || {}),
      key: card.__sqUniversalItem?.key || `recommend-${clean(card.dataset.productId || card.dataset.productHandle)}|${clean(card.dataset.variantId)}`,
      productId: clean(card.dataset.productId || card.__sqUniversalItem?.productId),
      variantId: clean(card.dataset.variantId || card.__sqUniversalItem?.variantId),
      handle: clean(card.dataset.productHandle || card.__sqUniversalItem?.handle),
      title: clean(card.dataset.productTitle || card.__sqUniversalItem?.title),
      url: clean(card.dataset.productUrl || card.__sqUniversalItem?.url),
      image: clean(card.dataset.productImage || card.__sqUniversalItem?.image),
      price: clean(card.dataset.productPrice || card.__sqUniversalItem?.price),
      quantity
    };
  };

  const itemsForAction = (button) => {
    const controller = controllerFor(button);
    if (button.matches('[data-lcs-favorites-add-selected],[data-lcs-favorites-buy-selected]')) {
      return controller?.getSelectedItems?.() || [];
    }
    if (button.matches('[data-lcs-expanded-add],[data-lcs-expanded-buy]')) {
      return controller?.getExpandedCartItems?.() || [];
    }
    const favorite = getItemFromFavoriteCard(button);
    if (favorite) return [favorite];
    const recommendation = getItemFromRecommendationCard(button);
    return recommendation ? [recommendation] : [];
  };

  const mergeLines = (items) => {
    const merged = new Map();
    items.forEach((item) => {
      const id = clean(item?.variantId).split('/').pop();
      if (!/^\d+$/.test(id)) return;
      const quantity = positiveInteger(item.quantity);
      const existing = merged.get(id);
      if (existing) existing.quantity += quantity;
      else merged.set(id, { id: Number(id), quantity });
    });
    return Array.from(merged.values());
  };

  const drawerComponents = () => Array.from(document.querySelectorAll(DRAWER_COMPONENT_SELECTOR));
  const drawerDialog = (component) => component?.querySelector('dialog');
  const drawerIsOpen = (component) => {
    if (!(component instanceof Element)) return false;
    const dialog = drawerDialog(component);
    return Boolean(
      dialog?.open
      || component.hasAttribute('open')
      || component.classList.contains('is-open')
      || component.classList.contains('active')
      || component.getAttribute('aria-hidden') === 'false'
    );
  };

  const primaryDrawer = () => drawerComponents().find(drawerIsOpen) || drawerComponents()[0] || null;

  const getCartSectionIds = () => {
    const ids = [];
    drawerComponents().forEach((component) => {
      try {
        component.getSectionsToRender?.().forEach((entry) => {
          const id = clean(entry?.section || entry?.id);
          if (id) ids.push(id);
        });
      } catch (_) {}
      const section = component.closest('[id^="shopify-section-"]');
      if (section) ids.push(section.id.replace('shopify-section-', ''));
      if (component.dataset.sectionId) ids.push(component.dataset.sectionId);
    });
    document.querySelectorAll('#cart-icon-bubble,[data-cart-count-bubble]').forEach((element) => {
      const section = element.closest('[id^="shopify-section-"]');
      if (section) ids.push(section.id.replace('shopify-section-', ''));
    });
    ids.push('cart-drawer', 'cart-icon-bubble');
    return Array.from(new Set(ids.filter(Boolean))).slice(0, 5);
  };

  const fetchCart = async () => {
    const response = await fetch(`${rootPath()}cart.js`, {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin'
    });
    if (!response.ok) throw new Error('Could not refresh the cart.');
    return response.json();
  };

  const addLines = async (lines) => {
    const sectionIds = getCartSectionIds();
    const payload = { items: lines };
    if (sectionIds.length) {
      payload.sections = sectionIds;
      payload.sections_url = location.pathname;
    }
    const response = await fetch(`${rootPath()}cart/add.js`, {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(payload)
    });
    const data = await response.json().catch(() => ({}));
    if (!response.ok) throw new Error(data.description || data.message || 'Could not add this item to cart.');
    return { cart: await fetchCart(), sections: data.sections || null };
  };

  const closeExpandedCompletely = () => {
    allPages().forEach((page) => {
      const controller = page.__lcsFavoritesPage;
      const modal = modalForPage(page);
      if (controller?.closeExpanded && (modal?.hidden === false || controller.activeExpandedItem)) {
        try { controller.closeExpanded(); } catch (_) {}
      }
      if (modal) {
        modal.hidden = true;
        modal.classList.remove('is-ready', 'has-expanded-options');
        modal.setAttribute('aria-hidden', 'true');
      }
      page.classList.remove('lcs-expanded-active');
      page.querySelectorAll('.lcs-favorite-expanded__menu').forEach((menu) => menu.classList.remove('has-expanded-options'));
    });

    document.querySelectorAll(EXPANDED_SELECTOR).forEach((modal) => {
      modal.hidden = true;
      modal.classList.remove('is-ready', 'has-expanded-options');
      modal.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll(OPENERS).forEach((button) => button.setAttribute('aria-expanded', 'false'));

    try { window.LCSExpandedModalLock?.unlock?.(); } catch (_) {}
    document.documentElement.classList.remove('lcs-expanded-solid-lock');
    document.body.classList.remove('lcs-expanded-solid-lock');
    document.documentElement.style.removeProperty('--lcs-modal-scroll-y');
    document.documentElement.style.overflow = '';
    document.body.style.overflow = '';
    document.body.style.position = '';
    document.body.style.inset = '';
    document.body.style.top = '';
    document.body.style.width = '';
  };

  const dispatchCartUpdate = (cart, sections) => {
    const detail = { cart, sections, source: 'favorites' };
    document.documentElement.dispatchEvent(new CustomEvent('cart:update', { bubbles: true, detail }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true, detail }));
    window.dispatchEvent(new CustomEvent('cart:updated', { detail }));
  };

  const openSolidDrawer = async () => {
    await nextFrame();
    await nextFrame();

    let component = drawerComponents().find(drawerIsOpen);
    if (component) {
      component.classList.add('active', 'is-open');
      component.removeAttribute('aria-hidden');
      return component;
    }

    component = primaryDrawer();
    if (component) {
      try {
        if (typeof component.open === 'function') component.open();
        else if (typeof component.show === 'function') component.show();
        else if (typeof component.showModal === 'function') component.showModal();
        else {
          const dialog = drawerDialog(component);
          if (dialog && !dialog.open) dialog.showModal();
          else component.setAttribute('open', '');
        }
      } catch (_) {}
      await nextFrame();
      if (drawerIsOpen(component)) return component;
    }

    const opener = document.querySelector('[data-cart-drawer-toggle],[data-cart-drawer-open],[aria-controls="CartDrawer"],[aria-controls="cart-drawer"]');
    if (opener instanceof HTMLElement) opener.click();
    return component;
  };

  const goToShopifyCheckout = () => {
    const form = document.createElement('form');
    form.method = 'post';
    form.action = `${rootPath()}cart`;
    form.acceptCharset = 'UTF-8';
    form.noValidate = true;
    form.style.display = 'none';

    const checkout = document.createElement('input');
    checkout.type = 'hidden';
    checkout.name = 'checkout';
    checkout.value = 'Checkout';

    form.appendChild(checkout);
    document.body.appendChild(form);
    form.submit();
  };

  const showError = (message, button) => {
    const controller = controllerFor(button) || activePage()?.__lcsFavoritesPage;
    if (controller?.showNotice) controller.showNotice(message);
    else console.error('[Serein Queen cart]', message);
  };

  const setBusy = (button, busy, buy) => {
    if (!(button instanceof HTMLButtonElement)) return;
    const label = button.querySelector('span');
    if (busy) {
      if (!button.dataset.sqOriginalLabel && label) button.dataset.sqOriginalLabel = label.textContent || '';
      button.dataset.sqCartBusy = 'true';
      button.disabled = true;
      button.setAttribute('aria-busy', 'true');
      if (label) label.textContent = buy ? 'Opening…' : 'Adding…';
      return;
    }
    button.dataset.sqCartBusy = 'false';
    button.disabled = false;
    button.removeAttribute('aria-busy');
    if (label && button.dataset.sqOriginalLabel) label.textContent = button.dataset.sqOriginalLabel;
    delete button.dataset.sqOriginalLabel;
  };

  const runAction = async (button) => {
    if (button.dataset.sqCartBusy === 'true') return;
    const buy = button.matches(BUY_SELECTOR);
    const lines = mergeLines(itemsForAction(button));
    if (!lines.length) {
      showError('Select a valid product option first.', button);
      return;
    }

    setBusy(button, true, buy);
    try {
      const { cart, sections } = await addLines(lines);
      closeExpandedCompletely();

      if (buy) {
        goToShopifyCheckout();
        return;
      }

      dispatchCartUpdate(cart, sections);
      await openSolidDrawer();
    } catch (error) {
      showError(error.message || 'Could not add this item to cart.', button);
    } finally {
      if (!buy) setBusy(button, false, buy);
    }
  };

  window.addEventListener('click', (event) => {
    const button = event.target instanceof Element ? event.target.closest(ACTION_SELECTOR) : null;
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    event.stopImmediatePropagation();
    void runAction(button);
  }, true);

  document.addEventListener('click', (event) => {
    const close = event.target instanceof Element
      ? event.target.closest('cart-drawer-component dialog .button--close,cart-drawer-component dialog [data-dialog-close],cart-drawer-component dialog button[aria-label*="Close" i],cart-drawer-component dialog button[aria-label*="close" i]')
      : null;
    if (!close) return;
    requestAnimationFrame(() => {
      drawerComponents().forEach((component) => {
        if (drawerDialog(component)?.open) return;
        component.classList.remove('active', 'is-open');
        component.removeAttribute('open');
      });
    });
  }, true);
})();
